import React, { lazy, Suspense } from 'react';
import KeepAlive, { AliveScope } from 'react-activation'
import { Router, Switch, Route } from 'react-router-dom';
import history from '../utils/history'
import { isNewVersion } from '../utils/common';

const Wrong = lazy(() => import('../h5/Wrong/Wrong'));
const WrongBook = lazy(() => import('../h5/WrongBook/WrongBook'));
const WrongBookDetail = lazy(() => import('../h5/WrongBookDetail/WrongBookDetail'));
const Exercise = lazy(() => import('../h5/Exercise/Exercise'));
const PrintList = lazy(() => import('../h5/PrintList/PrintList'));

const Wrong2 = lazy(() => import('../V2H5/Wrong/Wrong'));
const WrongBook2 = lazy(() => import('../V2H5/WrongBook/WrongBook'));
const WrongBookDetail2 = lazy(() => import('../V2H5/WrongBookDetail/WrongBookDetail'));
const Exercise2 = lazy(() => import('../V2H5/Exercise/Exercise'));
const PrintList2 = lazy(() => import('../V2H5/PrintList/PrintList'));

const Wrong3 = lazy(() => import('../V3H5/Wrong/Wrong'));
const WrongBook3 = lazy(() => import('../V3H5/WrongBook/WrongBook'));
const WrongBookDetail3 = lazy(() => import('../V3H5/WrongBookDetail/WrongBookDetail.tsx'));
const Exercise3 = lazy(() => import('../V3H5/Exercise/Exercise'));
const PrintList3 = lazy(() => import('../V3H5/newPrintList/NewPrintList'));
const PrintPreview = lazy(() => import('../V3H5/PrintPreview'));
const CarefullyChosen = lazy(() => import('../V3H5/CarefullyChosen/CarefullyChosenList'));
const CarefullyChosenDetail = lazy(() => import('../V3H5/CarefullyChosen/CarefullyChosenDetail'));
const MyCollection = lazy(() => import('../V3H5/MyCollection/MyCollection'));
const CollectAskDetail = lazy(() => import('../V3H5/MyCollection/CollectAskDetail'));

const Box = lazy(() => import('../Box/Index'))

const RecommendDetail = lazy(() => import('../h5/RecommendDetail'));
const RecommendDetail2 = lazy(() => import('../V2H5/RecommendDetail'));
const RecommendList = lazy(() => import('../h5/RecommendList'));

const SelectiveNotes = lazy(() => import('../V3H5/SelectiveNotes/SelecttiveNotesList'));
const SelectiveNotesDetail = lazy(() => import('../V3H5/SelectiveNotes/SelectiveNotesDetail'));
export default () =>
  <AliveScope>
    <Router history={history}>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route path='/wrong' exact component={Wrong} />
          <Route path='/wrongbook' exact component={WrongBook} />
          <Route path='/wrongbookdetail' exact component={WrongBookDetail} />
          <Route path='/exercise' exact component={Exercise} />
          <Route path='/printlist' exact component={PrintList} />

          <Route path='/v2/wrong' exact component={Wrong2} />
          <Route path='/v2/wrongbook' exact component={WrongBook2} />
          <Route path='/v2/wrongbookdetail' exact component={WrongBookDetail2} />
          <Route path='/v2/exercise' exact component={Exercise2} />
          <Route path='/v2/printlist' exact component={PrintList2} />

          <Route path='/v3/wrong' exact component={Wrong3} />
          <Route path='/v3/wrongbook' exact component={WrongBook3} />
          <Route path='/v3/wrongbookdetail' render={props => (
            isNewVersion()
              ? <KeepAlive name='keepliveComponent' when={() => { return localStorage.getItem('isComplete') }} id={`listOfSubjectId${localStorage.getItem('isComplete')}`}>
                <WrongBookDetail3 {...props} />
              </KeepAlive>
              : <KeepAlive name='keepliveComponent' when={() => { return localStorage.getItem('subjectCode') }} id={`listOfSubjectId${localStorage.getItem('isComplete')}`}>
                <WrongBookDetail3 {...props} />
              </KeepAlive>
          )} />
          <Route path='/v3/exercise' exact component={Exercise3} />
          <Route path='/v3/newPrintlist' exact component={PrintList3} />
          <Route path='/v3/printpreview' exact component={PrintPreview} />
          <Route path='/v3/carefullyChosen' exact render={props => (<KeepAlive><CarefullyChosen {...props}/></KeepAlive>) } />
          <Route path='/v3/carefullyChosenDetail' exact component={CarefullyChosenDetail} />
          <Route path='/box' component={Box} />
          <Route path='/v2/recommendDetail' component={RecommendDetail2} />
          <Route path='/recommendDetail' component={RecommendDetail} />
          <Route path='/recommendList' render={props => (<KeepAlive><RecommendList {...props}/></KeepAlive>) } />
          <Route path='/v3/myCollection' exact render={props => (<KeepAlive><MyCollection {...props}/></KeepAlive>) } />
          <Route path='/v3/myCollection/collectAsk/askDetail' exact component={CollectAskDetail} />

          <Route path='/v3/selectiveNotes' exact render={props => (<KeepAlive><SelectiveNotes {...props}/></KeepAlive>) } />
          <Route path='/v3/selectiveNotesDetail' exact render={props => (<KeepAlive><SelectiveNotesDetail {...props}/></KeepAlive>) } />
        </Switch>
      </Suspense>
    </Router>
  </AliveScope>;
